import { Overlay, OverlayPositionBuilder } from '@angular/cdk/overlay';
import { Directive, ElementRef, Input } from '@angular/core';
import { PalantirTooltipDirective } from './tooltip.directive';

@Directive({
  selector: '[palantirTooltipWhenTruncated]',
  standalone: false,
})
export class PalantirTooltipWhenTruncatedDirective extends PalantirTooltipDirective {
  @Input('palantirTooltipWhenTruncated') public override text: string = '';

  public constructor(
    overlayPositionBuilder: OverlayPositionBuilder,
    elementRef: ElementRef<HTMLElement>,
    overlay: Overlay,
  ) {
    super(overlayPositionBuilder, elementRef, overlay);
  }

  public override show(): void {
    const element = this.elementRef.nativeElement;

    if (element.scrollWidth > element.clientWidth) {
      super.show();
    }
  }
}
